import { when } from "util/support";
import { MultiFilePreview } from "lib/upload";
import { FileDropArea } from "ui/widgets/FileUploader";
import type { FileInputProps } from "./types";

const FileInput = <TFormField extends string>({
    file,
    files,
    multiple,
    name,
    setFieldValue,
    setFieldTouched,
    slots = {},
    ...restProps
}: FileInputProps<TFormField>) => (
    <FileDropArea
        onDrop={files => {
            setFieldValue(
                name,
                multiple
                    ? files
                    : files[0],
            );
            setTimeout(() => setFieldTouched(name, true, true));
        }}
        helperText={file && (
            <MultiFilePreview
                files={[file]}
                onRemove={when(
                    restProps.disabled,
                    null,
                    () => () => {
                        setFieldValue(name, null);
                        setTimeout(() => setFieldTouched(name, true, true));
                    }
                )}
            />
        )}
        {...restProps}
        sx={{
            '& .MuiTypography-subtitle2.MuiTypography-noWrap': {
                whiteSpace: 'normal'
            },
            ...restProps.sx
        }}
        multiple={multiple}
        file={file}
        files={files}
        slots={{
            singleFilePreview: <></>,
            ...slots
        }}
    />
);

export default FileInput;
